import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getAvailableCupsAndSeasonsOptionsAPICall, getCupsAndSeasonsNotificationsAPICall, getSubscribedCupsAndSeasonsOptionsAPICall, markAsReadNotificationAPICAll, markGameAsReadAPICall, subscribeCupsAndSeasonsOptionsAPICall, unsubscribeCupsAndSeasonsOptionsAPICall } from "../api/user/userNotificationsService";
import { useWebSocketDataService } from "./useWebSocketDataService";
import WebSocketObserver from "../helper/websocket/WebSocketObserver";

export const UserNotificationsServiceContext = createContext({
    cupsSeasonsNotifications: [],
    selectedNotification: undefined,
    setCupsSeasonsNotifications: () => { },
    setSelectedNotification: () => { },
    getAvailableCupsAndSeasonsOptions: () => { },
    getSubscribedCupsAndSeasonsOptions: () => { },
    subscribeCupsAndSeasonsOptions: () => { },
    unsubscribeCupsAndSeasonsOptions: () => { },
    getCupsAndSeasonsNotifications: () => { },
    markAsReadNotification: () => { },
    markGameAsRead: () => { },
    notificationsWsHandler: () => { },
});


const UerNotificationsServiceProvider = ({ children }) => {

    const [cupsSeasonsNotifications, setCupsSeasonsNotifications] = useState([]);
    const [selectedNotification, setSelectedNotification] = useState(null)

    const getAvailableCupsAndSeasonsOptions = useCallback(
        async (
            callbackFunction,
            callbackError,
        ) => {
            try {
                await getAvailableCupsAndSeasonsOptionsAPICall(
                    function (response) {
                        callbackFunction(response.data);
                    },
                    function (error) {
                        callbackError(error);
                    }
                );
            } catch (error) {
                callbackError(error);
            }
        }
    );

    const getSubscribedCupsAndSeasonsOptions = useCallback(
        async (
            callbackFunction,
            callbackError,
        ) => {
            try {
                await getSubscribedCupsAndSeasonsOptionsAPICall(
                    function (response) {
                        callbackFunction(response.data);
                    },
                    function (error) {
                        callbackError(error);
                    }
                );
            } catch (error) {
                callbackError(error);
            }
        }
    );
    const getCupsAndSeasonsNotifications = useCallback(
        async (
            page,
            callbackFunction,
            callbackError,
        ) => {
            try {
                await getCupsAndSeasonsNotificationsAPICall(
                    page,
                    function (response) {
                        setCupsSeasonsNotifications(response.data)
                        callbackFunction(response.data);
                    },
                    function (error) {
                        callbackError(error);
                    }
                );
            } catch (error) {
                callbackError(error);
            }
        }
    );

    const subscribeCupsAndSeasonsOptions = useCallback(
        async (
            data,
            callbackFunction,
            callbackError,
        ) => {
            try {
                await subscribeCupsAndSeasonsOptionsAPICall(
                    data,
                    function (response) {

                        callbackFunction(response.data);
                    },
                    function (error) {
                        callbackError(error);
                    }
                );
            } catch (error) {
                callbackError(error);
            }
        }
    );
    const unsubscribeCupsAndSeasonsOptions = useCallback(
        async (
            data,
            callbackFunction,
            callbackError,
        ) => {
            try {
                await unsubscribeCupsAndSeasonsOptionsAPICall(
                    data,
                    function (response) {
                        callbackFunction(response.data);
                    },
                    function (error) {
                        callbackError(error);
                    }
                );
            } catch (error) {
                callbackError(error);
            }
        }
    );

    const markAsReadNotification = useCallback(
        async (
            ids,
            callbackFunction,
            callbackError,
        ) => {
            try {
                await markAsReadNotificationAPICAll(
                    ids,
                    function (response) {
                        callbackFunction(response.data);
                    },
                    function (error) {
                        callbackError(error);
                    }
                );
            } catch (error) {
                callbackError(error);
            }
        }
    );
    const markGameAsRead = useCallback(
        async (
            data,
            callbackFunction,
            callbackError,
        ) => {
            try {
                await markGameAsReadAPICall(
                    data,
                    function (response) {
                        callbackFunction(response.data);
                    },
                    function (error) {
                        callbackError(error);
                    }
                );
            } catch (error) {
                callbackError(error);
            }
        }
    );

    const notificationsWsHandler = (message) => {
        console.log(message)

    }


    return (
        <UserNotificationsServiceContext.Provider
            value={{
                getAvailableCupsAndSeasonsOptions,
                getSubscribedCupsAndSeasonsOptions,
                cupsSeasonsNotifications,
                setCupsSeasonsNotifications,
                subscribeCupsAndSeasonsOptions,
                unsubscribeCupsAndSeasonsOptions,
                getCupsAndSeasonsNotifications,
                markAsReadNotification, notificationsWsHandler,
                markGameAsRead,
                selectedNotification, setSelectedNotification
            }}
        >
            {children}
        </UserNotificationsServiceContext.Provider>
    );
};
export const useUserNotificationsService = () => useContext(UserNotificationsServiceContext);
export default UerNotificationsServiceProvider;
